const tooltipDirective = (app: {
  directive: (
    arg0: string,
    arg1: {
      mounted(el: any, binding: any): void;
      updated(el: any, binding: any): void;
    }
  ) => void;
}) => {
  app.directive("tooltip", {
    mounted(el: any, binding: any) {
      init(el, binding);
    },
    updated(el: any, binding: any) {
      init(el, binding);
    },
  });
};

function init(el: HTMLElement, binding: { arg: string; value: string }) {
  const position = binding.arg || "top";
  const tooltipText = binding.value || "Tooltip text";
  el.setAttribute("position", position);
  el.setAttribute("tooltip", tooltipText);

  // Add the event listener for hiding the tooltip on click
  el.addEventListener("click", () => {
    setTimeout(() => {
      el.setAttribute("tooltip", "");
    }, 100); // Delay to allow click event to register before hiding tooltip
  });

  // Add event listener for showing the tooltip on hover
  el.addEventListener("mouseenter", () => {
    el.setAttribute("tooltip", tooltipText);
    applyTooltipStyles(el, position);
  });

  // Optional: Remove the event listener when the directive is unbound
  el.addEventListener("mouseleave", () => {
    el.setAttribute("tooltip", "");
    removeTooltipStyles(el);
  });
}

function applyTooltipStyles(el: HTMLElement, position: string) {
  const tooltipStyle = document.createElement("style");
  tooltipStyle.id = "tooltip-style";
  tooltipStyle.textContent = `
    [tooltip]:after {
      content: attr(tooltip);
      position: absolute;
      background-color: rgba(71, 84, 103, 1);
      background: rgba(71, 84, 103, 1);
      color: #fff;
      width: auto;
      min-width: 280px;
      white-space: wrap;
      z-index: 1000;
      opacity: 1;
      ${getPositionStyles(position)}
    }
  `;
  document.head.appendChild(tooltipStyle);
}

function removeTooltipStyles(el: HTMLElement) {
  const tooltipStyle = document.getElementById("tooltip-style");
  if (tooltipStyle) {
    tooltipStyle.remove();
  }
}

function getPositionStyles(position: string): string {
  switch (position) {
    case "top":
      return "bottom: 100%; left: 50%; transform: translateX(-50%);";
    case "bottom":
      return "top: 100%; left: 50%; transform: translateX(-50%);";
    case "left":
      return "right: 100%; top: 50%; transform: translateY(-50%);";
    case "right":
      return "left: 100%; top: 50%; transform: translateY(-50%);";
    default:
      return "bottom: 100%; left: 50%; transform: translateX(-50%);";
  }
}

export default tooltipDirective;
